
import {initWebComponent} from "@/helpers/web-component-helper";
import {AutoCompleteComponent} from "@/components/autocomplete/auto-complete-component";
// import * as bootstrap from "bootstrap";
import {updateLanguage} from "@/modules/language/language";
import {
    disableElementsBySelector,
    getAllBySelector,
    getBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {isMobile} from "@/helpers/mobile-helper";
import {getFilterByKey} from "@/helpers/filter/filter-helper";
import {clickAutoComplete} from "@/helpers/autocomplete-helper";
import {finishDrawing, stopDraw, undoDrawGeometry} from "@/helpers/ol/draw/ol-draw-polygon-helper.js";
import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper.js";

const template = document.createElement('template');
let innerHTML = `
    <div class="input-group ml-2 bg-light" style="width: max-content;">
      <span class="input-group-append">
      <header-button id="btnSearchAutocomplete" class="mt-1" data-icon="fa fa-search" data-tooltip="search"></header-button>
      </span>
      <auto-complete></auto-complete>
        <span class="input-group-append header-search-hide">
          <div class="btn-group project-actions">
            <button type="button" class="btn btn-outline-secondary btn-sm borderless text-transform-none dropdown-toggle popper-header" data-testid="header_search_button_ellipsis" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="fa fa-ellipsis-v"></span>
                  <div class="popper-tooltip" role="tooltip" data-popper-placement="bottom">
                      Zoeken op adres, perceel of coördinaat
                      <div class="arrow" data-popper-arrow=""></div>
                  </div>        
            </button>
            <div class="dropdown-menu" data-testid="header_search_dropdown_ellipsis">
              <h6 class="dropdown-header">Zoeken op</h6>
                <li class="dropdown-item cursor-pointer liHomeFindAdressType active" data-search-type="0">Adres</li>
                <li class="dropdown-item cursor-pointer liHomeFindAdressType" data-search-type="1">Perceel</li>
                <li class="dropdown-item cursor-pointer liHomeFindAdressType" data-search-type="2">Coördinaat</li>
            </div>
          </div>
        </span>`

if(isMobile()) {
    innerHTML += `
      <span class="input-group-append header-search-hide">
        <header-filter></header-filter>
      </span>
      <span class="input-group-append header-search-hide mt-1">
        <header-login class="d-none divProfileMenu"></header-login>
        <header-logout class="d-none"></header-logout>
      </span>
      <span class="input-group-append header-search-hide mt-1">
       <header-info class="divMenuHelp d-none"></header-info>
      </span>
      <span class="input-group-append header-search-hide mt-1">
      <header-settings class="d-none"></header-settings>
      </span>
    
`
}

      innerHTML += `</div>
    <div class="row d-none" id="divFilterToolsMeasureDrawButtonsMobile">
        <div class="col-12 mt-2">
            <button data-type="save" disabled class="btn btn-outline-secondary btn-sm btn-block text-transform-none" href="#">
                <span data-type="save" class="fa fa-stop float-left mt-1"></span> Tekening afsluiten
            </button>
        </div>
        <div class="col-12 mt-2">
            <button data-type="undo" class="btn btn-outline-secondary btn-sm btn-block text-transform-none" href="#">
                <span data-type="undo" class="fa fa-undo float-left mt-1"></span> Laatste klik ongedaan maken
            </button>
        </div>
        <div class="col-12 mt-2">
            <button data-type="cancel" class="btn btn-outline-secondary btn-sm btn-block text-transform-none" href="#">
                <span data-type="cancel" class="fa fa-ban float-left mt-1"></span> Annuleren
            </button>
        </div>
    </div>

`

template.innerHTML = innerHTML

export class HeaderSearchComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        window.activeAdressSearchType = 0

        this.querySelector('.dropdown-menu').addEventListener('click', event => {
            const target = event.target.closest('.liHomeFindAdressType')
            removeClassBySelector('.liHomeFindAdressType', 'active')
            target.classList.add('active')

            window.activeAdressSearchType = target.dataset.searchType

            let placeHolder
            let filter
            switch(window.activeAdressSearchType) {
                case "0":
                    placeHolder = window.settings.Snelzoeken
                    break;
                case "1":
                    placeHolder = window.settings.SnelzoekenPerceel
                    break;
                case "2":
                    placeHolder = window.settings.SnelzoekenCoordinate
                    break;
                default:
                    let filter = getFilterByKey(target.dataset.filterKey)
                    let formAttributeID = target.dataset.formAttributeId
                    const formAttribute = filter.form.form_attributes.find(formAttribute => formAttribute.ID === parseInt(formAttributeID))
                    placeHolder = `Zoek in ${filter.PresentationName.toLowerCase()} op ${formAttribute.attribute.Display.toLowerCase()}`
                    break;
            }

            document.querySelectorAll('.iptSearchAddress').forEach(element => {
                element.setAttribute('placeholder', placeHolder)
                element.value = ''
            })

            updateLanguage()
        })

        this.querySelector('#btnSearchAutocomplete').addEventListener('click', () => {
            clickAutoComplete()
        })

        this.querySelectorAll('button').forEach(element => {
            element.addEventListener('click', (evt) => {
                switch (evt.target.dataset.type) {
                    case 'save':
                        finishDrawing()
                        disableElementsBySelector('button[data-type="save"]')
                        break
                    case 'undo':
                        undoDrawGeometry()
                        disableElementsBySelector('button[data-type="save"]')
                        break;
                    case 'cancel':
                        stopDraw()
                        showLayerInfoButton('layer-info-filter')
                        showElementsBySelector('layer-info-filter .btnHideInfoMenu')
                        hideElementsBySelector('#divFilterToolsMeasureDrawButtonsMobile')
                        disableElementsBySelector('button[data-type="save"]')
                        getAllBySelector('ol-draw-geometry input').forEach(element => {
                            element.checked = false
                        })
                        break;
                }
            })
        })
    }
}


window.customElements.define("auto-complete", AutoCompleteComponent);
